import axios from "axios"
import { useNotifications } from "hooks/useNotification"
import { useThunkDispatch } from "hooks/useThunkDispatch"
import { useEffect, useState } from "react"
import { loginSuccess, otpFailure } from "appRedux/reducers/userReducer"
import AuthService from "services/auth.service"
import { getItem, setItem } from "services/localStorage.service"
import { redirectTo } from "utils/links"
import { AUTH_VERIFY_URL } from "utils/apiConfig"
import { setAuthorizationHeader } from "utils/auth"

const service = new AuthService()

export const Otp = () => {
  const [otp, setOtp] = useState(Array(6).fill(""))
  const [error, setError] = useState(null)

  const dispatch = useThunkDispatch()
  const { successMessage } = useNotifications()

  useEffect(() => {
    dispatch(otpFailure(null))
  }, [])

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false

    const newOtp = [...otp]
    newOtp[index] = element.value
    setOtp(newOtp)

    // Focus on next input field
    if (element.nextSibling) {
      element.nextSibling.focus()
    }
  }

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && otp[index] === "" && index !== 0) {
      event.preventDefault()
      const newOtp = [...otp]
      newOtp[index - 1] = ""
      setOtp(newOtp)

      if (event.target.previousSibling) {
        event.target.previousSibling.focus()
      }
    }
  }

  const handlePaste = (event) => {
    const paste = event.clipboardData.getData("text")
    if (!/^\d{6}$/.test(paste)) {
      return
    }

    const newOtp = paste.split("")
    setOtp(newOtp)
    event.preventDefault()

    // Automatically submit the form after pasting
    // handleSubmit(event);
  }

  const resendCode = () => {
    service
      .resendOtp({ email: getItem("email") ?? "" })
      .then((resp) => {
        console.log(resp)
        successMessage("New OTP has been sent")
      })
      .catch((err) => {
        console.error(err)
      })
  }


  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      const response = await axios.post(AUTH_VERIFY_URL, {
        email: getItem("email") ?? "",
        otp,
      })
      // if (!response.data.success) {
      //   dispatch(loginFailure(response.data.message))
      // }
      dispatch(loginSuccess(response.data))
      setItem("x-auth-token", response.data.token)
      setItem("refreshToken", response.data.refreshToken)
      setAuthorizationHeader(response.data.token)
      redirectTo("/")
    } catch (res: any) {
      setError(res.response.data.message)
    }
  }


  return (
    <div className="h-screen flex flex-col items-center justify-center bg-surface gap-6">
      <div className="rounded-xl bg-ink px-5 py-3">
        <img
          alt="logo"
          src="/images/logo.png"
          className="w-36 h-auto mx-auto object-contain"
        />
      </div>
      <div className="card max-w-md w-full mx-4 text-center px-6 sm:px-8 py-8 shadow-card-md">
        <header className="mb-7">
          <h1 className="text-lg text-ink font-semibold mb-1">
            Email Verification
          </h1>
          <p className="text-sm text-ink-muted">
            Enter the 6-digit verification code that was sent to your email
          </p>
          {error && (
            <p className="text-red-600 mt-4 text-sm font-medium">{error}</p>
          )}
        </header>
        <form onSubmit={handleSubmit}>
          <div className="flex items-center justify-between gap-3">
            {otp.map((data, index) => (
              <input
                type="text"
                key={index}
                maxLength={1}
                value={data}
                onChange={(e) => handleChange(e.target, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onPaste={handlePaste}
                className="w-12 h-14 text-center text-2xl font-semibold tabular-nums text-ink bg-white border border-line hover:border-line-strong appearance-none rounded-lg p-0 outline-none focus:border-primary focus:shadow-focus"
                pattern="\d*"
              />
            ))}
          </div>
          <div className=" mt-4">
            <button
              type="submit"
              className="btn-primary w-full py-2.5"
            >
              Verify Account
            </button>
          </div>
        </form>
        <div className="text-sm text-ink-muted mt-4">
          Didn't receive code?{" "}
          <button onClick={resendCode} className="font-medium text-primary">
            Resend
          </button>
        </div>
      </div>
    </div>
  )
}
